import React from "react";
const Copyright = () => (
  <div>Copyright © {new Date().getFullYear()} PixelEdge</div>
);

export default Copyright;
